import { produce } from 'immer';
import { find, remove } from 'lodash/fp';
import { CANCEL_OPERATION } from 'app/store/operations/types.js';
import { extractError } from 'app/lib/error';
import {
    INITIALIZE_CONFIG,
    CHANGE_BLEND_TYPE,
    CHANGE_RIGHT_DATASET,
    CHANGE_LEFT_DATASET,
    ADD_CRITERIA,
    REMOVE_CRITERIA,
    SELECT_TAB,
    TOGGLE_DEDUPE_JOIN_KEYS,
    CLOSE_JOIN_EDITOR,
    UPDATE_JOIN_VIEW,
    CREATE_JOIN_VIEW
} from './types.js';

export const INITIAL_STATE = {
    config: {
        leftDatasetId: null,
        rightDatasetId: null,
        blendType: 'LEFT_OUTER',
        criteria: [],
        dedupeJoinKeys: true
    },
    error: null,
    validations: {},
    selectedTab: 'preview',
    isSubmitting: false
};

const makeCmp = (leftColumn, rightColumn) => (c) =>
    c.leftColumn === leftColumn && c.rightColumn === rightColumn;

export const blendReducer = produce((draft, action) => {
    switch (action.type) {
        case INITIALIZE_CONFIG:
            draft.config = action.payload;
            draft.selectedTab = INITIAL_STATE.selectedTab;
            break;

        case CHANGE_BLEND_TYPE:
            draft.config.blendType = action.payload.blendType;
            draft.error = null;
            draft.validations = {};
            break;

        case CHANGE_LEFT_DATASET:
            draft.config.leftDatasetId = action.payload.viewUid;
            draft.error = null;
            draft.validations = {};
            break;

        case CHANGE_RIGHT_DATASET:
            draft.config.rightDatasetId = action.payload.viewUid;
            draft.error = null;
            draft.validations = {};
            break;

        case TOGGLE_DEDUPE_JOIN_KEYS:
            draft.config.dedupeJoinKeys = !draft.config.dedupeJoinKeys;
            draft.error = null;
            draft.validations = {};
            break;

        case CREATE_JOIN_VIEW.STARTED:
        case UPDATE_JOIN_VIEW.STARTED: {
            draft.isSubmitting = true;
            break;
        }

        case CREATE_JOIN_VIEW.ENDED:
        case UPDATE_JOIN_VIEW.ENDED: {
            draft.isSubmitting = false;
            break;
        }

        case CREATE_JOIN_VIEW.FAILED:
        case CREATE_JOIN_VIEW.REJECTED:
        case UPDATE_JOIN_VIEW.FAILED:
        case UPDATE_JOIN_VIEW.REJECTED: {
            draft.error = extractError(action.payload);
            break;
        }
        case ADD_CRITERIA: {
            const { leftColumn, rightColumn } = action.payload;
            const cmp = makeCmp(leftColumn, rightColumn);

            if (!find(cmp, draft.config.criteria)) {
                draft.config.criteria.push({ leftColumn, rightColumn });
            }

            draft.error = null;
            draft.validations = {};

            break;
        }

        case REMOVE_CRITERIA: {
            const { leftColumn, rightColumn } = action.payload;
            const cmp = makeCmp(leftColumn, rightColumn);

            draft.config.criteria = remove(cmp, draft.config.criteria);
            draft.error = null;
            draft.validations = {};

            break;
        }

        case CANCEL_OPERATION:
            return INITIAL_STATE;

        case SELECT_TAB:
            draft.selectedTab = action.payload.tab;
            break;

        case CLOSE_JOIN_EDITOR:
            draft.config = INITIAL_STATE.config;
            draft.error = null;
            break;

        default:
            break;
    }
}, INITIAL_STATE);
